import {createMongoAbility} from '@casl/ability';
import {AbilityBuilder} from '@casl/ability';
import {Permission} from '../types/types';

export function defineAbilitiesFor(permissions: Permission[]) {
  const builder = new AbilityBuilder(createMongoAbility);

  for (const permission of permissions) {
    switch (permission.permissionCode) {
      case 'USERS_VIEW':
        builder.can(Permissions.View, Resources.Users);
        break;
      case 'CLIENTS_VIEW':
        builder.can(Permissions.View, Resources.Clients);
        break;
      case 'LIO_VIEW':
        builder.can(Permissions.View, Resources.Lio);
        break;
      case 'REPORTS_VIEW':
        builder.can(Permissions.View, Resources.Reports);
        break;
      case 'REPORT_CASE_TRENDS_VIEW':
        builder.can(Permissions.View, Resources.Reports_CaseTrends);
        break;
      case 'REPORT_INTAKE_AUDIT_VIEW':
        builder.can(Permissions.View, Resources.Reports_IntakeAudit);
        break;
      case 'REPORT_PROCESSING_IN_PROGRESS_VIEW':
        builder.can(Permissions.View, Resources.Reports_Processing_InProgress);
        break;
      case 'REPORT_PROCESSING_SUMMARY_VIEW':
        builder.can(Permissions.View, Resources.Reports_Processing_Summary);
        break;
      case 'REPORT_PROCESSING_EXCEPTIONS_VIEW':
        builder.can(Permissions.View, Resources.Reports_Processing_Exceptions);
        break;
      case 'REPORT_INTERACTIVE_VOLUME_VIEW':
        builder.can(Permissions.View, Resources.Reports_InteractiveVolume);
        break;
      case 'REPORT_USER_SUMMARY_VIEW':
        builder.can(Permissions.View, Resources.Reports_UserSummary);
        break;
      case 'REPORT_PRODUCTION_METRICS_VIEW':
        builder.can(Permissions.View, Resources.Reports_ProductionMetrics);
        break;
      case 'REPORT_INVOICE_VIEW':
        builder.can(Permissions.View, Resources.Reports_Invoices);
        break;
      case 'REPORT_AURORA_USER_HISTORY_VIEW':
        builder.can(Permissions.View, Resources.Reports_UserHistory);
        break;
      case 'REPORT_PROJECT_TRACKER_VIEW':
        builder.can(Permissions.View, Resources.Reports_ProjectTracker);
        break;
      case 'REPORT_BUDGET_TRACKER_VIEW':
        builder.can(Permissions.View, Resources.Reports_BudgetTracker);
        break;
      case 'REPORT_CONCIERGE_REPORTS_VIEW':
        builder.can(Permissions.View, Resources.Reports_Concierge);
        break;
      case 'REPORT_CONCIERGE_REPORTS_CREATE':
        builder.can(Permissions.View, Resources.Reports_ConciergeUpload);
        break;
      case 'RESTRICT_CUSTOM_UPLOAD':
        builder.can(Permissions.Access, Resources.Reports_RestrictCustomUpload);
        break;
      case 'ADD_SYSTEM_ADMIN':
        builder.can(Permissions.Add, Resources.AdminUsers);
        break;
      case 'ECA_ADMIN_ONEOF':
        builder.can(Permissions.Access, Resources.ECA_Admin);
        break;
      case 'MASTER_BUDGET_PRESENTATION':
        builder.can(
          Permissions.View,
          Resources.Project_EstimatedBudgetConsumption
        );
        break;
    }
  }

  const ability = builder.build();
  return ability;
}

export enum Permissions {
  View = 'View',
  Add = 'Add',
  //Update = 'Update',
  //Remove = 'Remove',
  Access = 'Access',
}

export enum Resources {
  Users = 'Users',
  AdminUsers = 'AdminUsers',
  Clients = 'Clients',
  Lio = 'Lio',
  Reports = 'Reports',
  Reports_CaseTrends = 'Case Trend Report',
  Reports_IntakeAudit = 'Intake Audit Report',
  Reports_Processing_InProgress = 'Processing (In Progress) Report',
  Reports_Processing_Summary = 'Processing (Summary) Report',
  Reports_Processing_Exceptions = 'Processing (Exceptions) Report',
  Reports_InteractiveVolume = 'Interactive Volume Report',
  Reports_UserSummary = 'User Summary Report',
  Reports_ProductionMetrics = 'Production Metrics Report',
  Reports_Invoices = 'Invoice Report',
  Reports_UserHistory = 'User History Report',
  Reports_ProjectTracker = 'Project Tracker Report',
  Reports_BudgetTracker = 'Budget Tracker Report',
  Reports_Concierge = 'Concierge Report',
  Reports_ConciergeUpload = 'Concierge Upload Report',
  Reports_RestrictCustomUpload = 'Restrict Custom Report Upload',
  ECA_Admin = 'ECA Administrator Access',
  Project_EstimatedBudgetConsumption = 'Show Estimated Budget Consumption',
}

export async function hasAdminAccess(userRoles: any[], clientId?: string) {
  if (!Array.isArray(userRoles)) return false;

  return userRoles.some(
    (roleObj) =>
      roleObj?.role?.roleCode == 'SYSTEM_ADMINISTRATOR' ||
      (roleObj?.role?.roleCode == 'CLIENT_ADMINISTRATOR' &&
        (!clientId || roleObj?.client?.clientId == clientId))
  );
}
